/**
 * @generated SignedSource<<683423317a19993f30cbf50285609a20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_sortedPhotos$data = ReadonlyArray<{
  readonly __typename: "ItemPhoto";
  readonly imageSkuXrefs: ReadonlyArray<{
    readonly skuId: string | null;
  } | null> | null;
  readonly " $fragmentType": "useItemMediaItems_sortedPhotos";
}>;
export type useItemMediaItems_sortedPhotos$key = ReadonlyArray<{
  readonly " $data"?: useItemMediaItems_sortedPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_sortedPhotos">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useItemMediaItems_sortedPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSkuXref",
      "kind": "LinkedField",
      "name": "imageSkuXrefs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skuId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "d3d9e898b6bc3b7602763838f41ddb20";

export default node;
